import { createClient } from '@connectrpc/connect';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RegistryRecordService } from '../../../../../gen/ts/mono/datagateway/v1/registry_records_connect';
import { RegistryEntityKind, ResolutionStatus, ResolveMode } from '../../../../../gen/ts/mono/datagateway/v1/registry_resolve_pb';
import { connectTransport } from '../../lib/connect/transport';
// REG-54 on the browser path: RegistryRecordService (sabaody routes
// /mono.datagateway.v1.RegistryRecordService/ to pangaea, which authorizes
// every call on the viewer's own principal; no internal secret crosses).
export const registryResolveClient = createClient(RegistryRecordService, connectTransport);
export const KIND_TO_PROTO = {
    CONTACT: RegistryEntityKind.CONTACT,
    COMPANY: RegistryEntityKind.COMPANY,
    GOVERNMENT_ORG: RegistryEntityKind.GOVERNMENT_ORG,
    VEHICLE: RegistryEntityKind.VEHICLE
};
export const LINKED_STATUSES = new Set([
    ResolutionStatus.MATCHED,
    ResolutionStatus.CREATED,
    ResolutionStatus.CREATED_POSSIBLE_DUPLICATE
]);
export const REGISTRY_LIST_KEYS = [
    'contact',
    'company profile',
    'companyProfile',
    'contract vehicle'
];
export function invalidateRegistryLists(qc) {
    for (const key of REGISTRY_LIST_KEYS)qc.invalidateQueries({
        queryKey: [
            key
        ]
    });
}
/** ResolveEntities for one observation; returns its Resolution. */ export function useResolveEntities() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ observation, mode, context })=>{
            const resp = await registryResolveClient.resolveEntities({
                observations: [
                    {
                        clientKey: 'picker',
                        ...observation
                    }
                ],
                mode,
                context: context ? {
                    kind: context.kind,
                    id: context.id
                } : undefined
            });
            const result = resp.results[0];
            if (!result) throw new Error('The registry returned no answer. Try again.');
            return result;
        },
        onSuccess: (r)=>{
            if (r.status === ResolutionStatus.CREATED) {
                for (const key of REGISTRY_LIST_KEYS)qc.invalidateQueries({
                    queryKey: [
                        key
                    ]
                });
            }
        }
    });
}
/** One DecideRegistryMatchCandidate call: the single transport both decide hooks use. */ export async function decideRegistryMatchCandidate(args) {
    const resp = await registryResolveClient.decideRegistryMatchCandidate({
        candidateId: args.candidateId,
        decision: args.decision,
        chosenRegistryId: args.chosenRegistryId ?? '',
        reason: args.reason ?? '',
        expectedRevision: args.expectedRevision ?? BigInt(0)
    });
    return resp.resolution;
}
/** DecideRegistryMatchCandidate (CONFIRM / CREATE_NEW) for the picker's prompt. */ export function useDecideRegistryMatchCandidate() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: decideRegistryMatchCandidate,
        onSuccess: ()=>{
            invalidateRegistryLists(qc);
        }
    });
}
export { ResolutionStatus, ResolveMode };
